import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=7af73c72&"
import script from "./Partners.vue?vue&type=script&lang=ts&"
export * from "./Partners.vue?vue&type=script&lang=ts&"
import style0 from "./Partners.vue?vue&type=style&index=0&id=7af73c72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports